/**
 * Danger zone section with delete show functionality
 */

import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Alert,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

interface ShowDangerZoneProps {
  showId: string;
  showTitle: string;
  holdCount: number;
  onDelete: () => void;
}

export const ShowDangerZone: React.FC<ShowDangerZoneProps> = ({
  showTitle,
  holdCount,
  onDelete,
}) => {
  return (
    <Card
      sx={{
        borderColor: 'error.main',
        borderWidth: 2,
        borderStyle: 'solid',
      }}
    >
      <CardContent>
        <Typography variant="h6" color="error" gutterBottom>
          Danger Zone
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {holdCount > 0 && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This show has {holdCount} hold{holdCount > 1 ? 's' : ''}. Deleting
            the show will also delete all associated holds.
          </Alert>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Deleting "{showTitle}" is permanent and cannot be undone. All
          associated data including holds, dates, and financial information will
          be permanently removed.
        </Typography>

        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onDelete}
        >
          Delete Show
        </Button>
      </CardContent>
    </Card>
  );
};
